<script setup>
defineProps({
  show: { type: Boolean, required: true, default: false },
});

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};
</script>

<template>
  <div
    v-if="show"
    class="scoped-wrapper"
  >
    <div class="scoped-modal">
      <div
        class="scoped-modal__close"
        aria-label="close"
        @click="close"
      >
        <BaseIconWithLabel
          image-name="/svg/icon-close.svg"
          after
          small
        >
          {{ $t('general.callToActionButton.close') }}
        </BaseIconWithLabel>
      </div>

      <div class="scoped-modal__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.scoped-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scoped-modal {
  background-color: white;
  padding: 2rem;
  border-radius: 1rem;
  width: 100%;
  max-width: 600px;

  &__close {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 2rem;
    cursor: pointer;
  }
}
</style>
